import { Mesh, MeshStandardMaterial, PointLight, Scene, Vector3 } from "three";
import AssetManager from "../utils/asset_manager";
import exp from "constants";

class Spots {
  constructor(poolLength: number, poolWidth: number, poolDepth: number) {
    this.poolLength = poolLength;
    this.poolWidth = poolWidth;
    this.poolDepth = poolDepth;
  }

  amount: number = 1;
  spotMesh: Mesh;
  spotMaterial: MeshStandardMaterial;

  spots: Mesh[] = [];
  spotLights: PointLight[] = [];

  timeOfDay: string = "day";

  poolLength: number;
  poolWidth: number;
  poolDepth: number;

  init() {
    this.spotMesh = AssetManager.getInstance().getAsset("spot") as Mesh;
  }

  updateAmount(amount: number, scene: Scene) {
    this.amount = amount;

    if (this.timeOfDay == "night") {
      this.onPoolSizeUpdate(
        this.poolLength,
        this.poolWidth,
        this.poolDepth,
        scene
      );
    }
    else {
      console.log('update amount by day : ', this.amount);
    }
  }

  onPoolSizeUpdate(
    poolLength: number,
    poolWidth: number,
    poolDepth: number,
    scene: Scene
  ) {
    this.poolLength = poolLength;
    this.poolWidth = poolWidth;
    this.poolDepth = poolDepth;

    // cleanup first
    this.cleanUp(scene, true);

    if (this.timeOfDay == "day") return;

    // calc the middle point for each spots along the pool length

    const step = poolLength / (this.amount + 1);

    for (let i = 0; i < this.amount; i++) {
      const spot = this.spotMesh.clone();
      spot.castShadow = false;
      spot.receiveShadow = false;

      spot.rotateY(-Math.PI / 2);
      spot.scale.setScalar(0.01);
      spot.position.set(-this.poolLength/2.0 + step*(i+1), -this.poolDepth/2.0, -this.poolWidth/2.0 + 0.01);

      // light

      const poolSpot = new PointLight(0xffffff, 1, 100);
      poolSpot.distance = 6;
      poolSpot.layers.set(1);
      poolSpot.intensity = 60;
      poolSpot.decay = 3;
      poolSpot.castShadow = false;
      poolSpot.receiveShadow = false;
      poolSpot.position.copy(spot.position.add( new Vector3(0, 0., 0.1)));

      this.spots.push(spot);
      this.spotLights.push(poolSpot);

      scene.add(spot);
      scene.add(poolSpot);
    }
  }

  private cleanUp(scene: Scene, sizeChanged: boolean = true) {
    console.log("cleaning up spots");
    this.spots.forEach((spot) => {
      spot.parent.remove(spot);
    });

    this.spotLights.forEach((spot) => {
        spot.parent.remove(spot);
    });

    this.spots = [];
    this.spotLights = [];
  }

  onTimeOfDayChanged(type: string, scene: Scene) {
    console.log("on time of day changed (in spots) : ", type);
    this.timeOfDay = type;
    if (type == "day") {
      
      this.cleanUp(scene, false);
    } else {
      console.log('on time of day changed : ', this.amount);
      this.onPoolSizeUpdate(
        this.poolLength,
        this.poolWidth,
        this.poolDepth,
        scene
      );
    }

    
    
  }
}

export default Spots;
